import { replaceValueAtPath } from 'helpers/utils'
import BoVersionTypes from 'store/actionTypes/boVersion'
import UserTypes from '../actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {}
}

const boVersion = (state = initialData, action = {}) => {
  const { payload } = action

  switch (action.type) {
    case BoVersionTypes.GET_BO_VERSIONS_SUCCESS:
      return {
        ...state,
        list: payload?.items || [],
        pagination: payload?.meta || {}
      }
    case BoVersionTypes.UPDATE_BO_VERSION_FILTER_SUCCESS:
      return replaceValueAtPath(state, 'filter', payload)
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default boVersion
